module.exports = {
      id: "product-category-specials-usage",
      viewBox: "0 0 256.313 256.313",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#product-category-specials-usage",
      toString: function () {
        return this.url;
      }
    }